import React, {useEffect, useState, useRef} from 'react'
import firebase from '../../firebase/config'
import {Link} from 'react-router-dom';
import moment from 'moment';
// import ModalGuide from '../../components/ModalGuide';
import utils from '../../firebase/utils';
import Compress from "react-image-file-resizer";
import {useLocation} from 'react-router-dom';
import { debounce } from '../../utils/debounce';
import { DatePickerCalendar , useDateInput, Calendar, DatePicker } from 'react-nice-dates'
import { es } from 'date-fns/locale'

function UploadPromotion() {

    let todayDate = moment().format("YYYY-MM-DD")
    let minDate = moment().format("YYYY-MM-DD")
    const [limitDate, setLimitDate] = useState(todayDate)

    function formatDate(d){
        let n = moment(d).format("DD/MM/YYYY")
        setLimitDate(n)
    }

    const [productsTypes, setProductsTypes] = useState([])
    const [palabrasClave, setPalabrasClave] = useState([])
    const [localidades, setLocalidades] = useState([])
    const [species, setSpecies] = useState([])
    const [razas, setRazas] = useState([])
    const [listErrors, setListErrors] = useState([])

    const [promoCode, setPromoCode] = useState("");
    const [titleValue, setTitleValue] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [palabra, setPalabra] = useState("")
    const [localidadId, setLocalidad] = useState("")
    const [soles, setSoles] = useState(0)
    const [btnMessage, setBtnMessage] = useState("Subir promoción");

    const [countryInfo, setCountryInfo] = useState({})
    const [user, setUser] = useState({})

    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [finalClientStatus, setFinalClientStatus] = useState(true);
    const [aliadoClientStatus, setAliadoClientStatus] = useState(false);
    const [petPointsStatus, setPetPointsStatus] = useState(false);
    const [showCalendar, setShowCalendar] = useState(true);
    const [showProdServModal, setShowProdServModal] = useState(false);

    const inputTag = useRef(null)
    const inputSku = useRef(null)
    const inputName = useRef(null)
    const inputDesc = useRef(null)
    const inputWord = useRef(null)
    const inputPeso = useRef(null)
    const inputPrice = useRef(null)
    const inputCantidad = useRef(null)
    const inputMinima = useRef(null)
    const hiddenFileInput = useRef(null);

    const [products, setProducts] = useState([])
    const [services, setServices] = useState([])
    const [listaPrueba, setListaPrueba] = useState([])
    const [listObjects, setListObjects] = useState([])
    const [listTitle, setListTitle] = useState([])
    const [listCombinations, setListCombinations] = useState([])
    const [listMain, setListMain] = useState([])
    const [listaCategorias, setListaCategorias] = useState([])
    const [listaCategoriasSelected, setListaCategoriasSelected] = useState([])
    const [listSearch, setListSearch] = useState([])
    
    let errorInputMsg = "Campo requerido"
    const [listPromotionadedElements, setListPromotionadedElements] = useState([
        "A",
        "B",
        "C",
        "D"
    ])

    const [tipoPromoValores, setTipoPromoValores] = useState({
        desc: 0,  
        lleva: 0,  
        paga: 0,  
        descSeg: 0 
    })

    const [promotion, setPromotion] = useState({
        cupos: 0,
        aplicaA: "",
        categoriaPromo: "",
        status: "",
        titulo: "",
        descripcion: "",
        condiciones: "",
        dirigido: "Selección",
        limitInQuotas: false,
        limitInTime: false,
        edad: "",
        tipoMascota: "Selección",
        dateStart: "",
        dateEnd: "",
    })

    const [file, setFile] = useState(null);
    const [url, setURL] = useState("");
    const [src, setImg] = useState('');

    const handleClick = event => {
        hiddenFileInput.current.click();
    };

    async function handleChange(e) {
        var file = e.target.files[0]
        Compress.imageFileResizer(
          file,
          600,
          300,
          "JPEG",
          10,
          0,
          (uri) => {
            setFile(uri)
            console.log(uri)
          },
          "file",
          600,
          300
        )
        setImg(URL.createObjectURL(file))
        setListErrors(listErrors.filter( prev => prev !== "img" ))
    }

    const getServices = async(id) =>{
        let tipos = [];
        let tipos2 = [];

        await firebase.db.collection("Localidades").where("aliadoId", "==", id).get().then(val => {
            val.docs.forEach(item => {
                tipos.push(item.data())
            })
        })

        Promise.all(tipos.map(async (doc) => {
            firebase.db.collection("Localidades").doc(doc.localidadId).collection("Servicios").get().then(val => {
                val.docs.forEach(item => {
                    let o1 = {
                        titulo: item.data().titulo,
                        img: item.data().urlImagen,
                        tipo: "",
                        id: item.data().servicioId,
                        tipoItem: "Servicio",
                        nombreLocalidad: doc.nombreLocalidad,
                        localidadId: doc.localidadId,
                    }
                    tipos2.push(o1)
                })
            })

        }))

        let allList = tipos2

        setTimeout(() => {
            setServices(allList)
        }, 500);
  
    }
    
    function searchByValueInPopUp(value, key) {
        let list = listMain.filter((prv)=>( prv[key] === value ))
        setListSearch(list)
    }

    const getProductos = async(id) =>{
        let tipos = [];

        await firebase.db.collection("Productos").where("aliadoId", "==", id).get().then(val => {
            val.docs.forEach(item => {
                let o1 = {
                    titulo: item.data().titulo,
                    img: item.data().urlImagen,
                    tipo: "",
                    id: item.data().productoId,
                    tipoItem: "Producto",
                    nombreLocalidad: item.data().categoria,
                    localidadId: "",
                }
                tipos.push(o1)
            })
        })

        setTimeout(() => {
            setProducts(tipos)
        }, 500);
  
    }
    
    const getAllCategories = async() =>{
        let tipos = [];
        await firebase.db.collection( promotion.categoriaPromo === "Servicio" ? "CategoriasServicios" : 'tipoProductos').get().then(val => {
            val.docs.forEach(item=>{
                item.id !== "Todas" && tipos.push(item.id)
                tipos.sort()
            })
            setListaCategorias(tipos)
        })
    }
  
    const getAllProdServ = async() =>{
        promotion.categoriaPromo === "Servicio" && setListMain(services)
        promotion.categoriaPromo === "Producto" && setListMain(products)
    }

    const getLocalidades = async(aliadoId) =>{
        let tipos = [];
        await firebase.db.collection('Localidades').where("aliadoId", "==", aliadoId).get().then(val => {
            val.docs.forEach(item=>{
                tipos.push(item.data())
                tipos.sort()
            })
            setLocalidades(tipos)
        })
    }

    const getProductsTypes = async() =>{
        let tipos = [];
        await firebase.db.collection('tipoProductos').get().then(val => {
            val.docs.forEach(item=>{
                tipos.push(item.id)
                tipos.sort()
            })
            tipos.pop("Todas")
            setProductsTypes(tipos)
        })
    }

    const getRazas = async(tipoM) =>{
        let tipos = [];
        await firebase.db.collection('Especies').doc(tipoM).collection("Razas").get().then(val => {
            val.docs.forEach(item=>{
                tipos.push(item.id)
                tipos.sort()
            })
            setRazas(tipos)
        })
    }

    const getPets = async() =>{
        let tipos = [];
        await firebase.db.collection('Especies').get().then(val => {
            val.docs.forEach(item=>{
                tipos.push(item.id)
                tipos.sort()
            })
            setSpecies(tipos)
        })
    }

    const handleKeyPress = (event) => {
        if(event.key === 'Enter' && palabra !== ""){
            setPalabrasClave([...palabrasClave, palabra])
            inputTag.current.value = ""
        }
    }

    const SuccessComponent = ({msg}) => {
        return (
            <div className="success-alert">
                <span className="material-icons mr-2">done</span>
                {msg}
                <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
            </div>
        )
    }

    const ErrorComponent = ({msg}) => {
      return (
          <div className="error-alert">
              <span className="material-icons mr-2">error</span>
              {msg}
              <div onClick={()=>{setError(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }

    
    function changeAplica(ap){
        ap === "Una o varias categorías" && getAllCategories(); 
        ap === "Uno o varios" && getAllProdServ(); 
    }

    function checkInputs(object){
        let val = 0
        let array = []
        let o = {
            aplicaA: object["aplicaA"],
            categoriaPromo: object["categoriaPromo"],
            status: object["status"],
            titulo: object["titulo"],
            descripcion: object["descripcion"],
            dateStart: object["dateStart"],
            dateEnd: object["dateEnd"],
        }

        o["img"] = src


        Object.keys(o).forEach(function(key) {
            if (o[key] === '' || o[key] <= 0) {
                val++
                array.push(key)
            }
        });
        if(val > 0){
            setListErrors(array)
            window.scrollTo(0, 0)
        }else{
            setListErrors([])
            uploadPromotion()
            console.log("Todo bien")
        }
    }

    function changeTipoCateSelected(tipo, i){

        let newLista = [...listaCategoriasSelected]
        newLista[i].tipo = tipo

        let tipoPrecioSegundoProd = {
            precioSegProd: 0
        }
        
        let tipoPrecioLlevaXY = {
            lleva: 0,
            paga: 0
        }
        
        let tipoPrecioDesc = {
            desc: 0
        }

        newLista[i]["precioValores"] = 
            tipo === "segundoProd" ? tipoPrecioSegundoProd 
            : tipo === "llevaXY" ? tipoPrecioLlevaXY : tipoPrecioDesc
            
        setListaCategoriasSelected(newLista)
    }
    
    function changeValCateSelected(tipo, i, val, val2){

        let newLista = [...listaCategoriasSelected]

        let tipoPrecioSegundoProd = {
            precioSegProd: val
        }
        
        let tipoPrecioLlevaXY = {
            lleva: val,
            paga: val2
        }
        
        let tipoPrecioDesc = {
            desc: val
        }

        newLista[i]["precioValores"] = 
            tipo === "segundoProd" ? tipoPrecioSegundoProd 
            : tipo === "llevaXY" ? tipoPrecioLlevaXY : tipoPrecioDesc
            
        setListaCategoriasSelected(newLista)
    }
        
    async function getValuePetPoint(pais){
        try {
            await firebase.db.collection("Ciudades").doc(pais).get().then((v)=>{
                let precioPP =  parseInt(v.data().valorPunto)
                setSoles(precioPP)
            })
        }catch(e){

        }
    }

    const [prevScrollPos, setPrevScrollPos] = useState(0);
    const [visible, setVisible] = useState(true);
  
    const handleScroll = debounce(() => {
      const currentScrollPos = window.pageYOffset;
  
      setVisible((prevScrollPos > currentScrollPos && prevScrollPos - currentScrollPos > 70) || currentScrollPos < 10);
  
      setPrevScrollPos(currentScrollPos);
    }, 100);
  
    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
  
      return () => window.removeEventListener('scroll', handleScroll);
  
    }, [prevScrollPos, visible, handleScroll]);
  
    const navbarStyles = {
      position: 'fixed',
      height: '65px',
      width: '83.3%',
      backgroundColor: 'white',
      zIndex: "11",
      textAlign: 'center',
      transition: 'top 0.6s',
      padding: "1% 2%",
      right: "0px",
      boxShadow: "0 0.125rem 0.625rem rgb(90 97 105 / 12%)"
    }

    function makeid(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
       }
       return result;
    }

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
          getLocalidades(val.aliadoId)
          getServices(val.aliadoId)
          getProductos(val.aliadoId)
          getValuePetPoint(val.pais)
          firebase.getCountryInfo(val.pais).then(async (val) => {
            setCountryInfo(val.data()) 
          })
        });
        setPromoCode(makeid(6))
        getProductsTypes()
        getPets()

    }, [])

    return (
        <div className="main-content-container container-fluid px-4">
            {error && <ErrorComponent msg={errorMsg === "" ? "Todos los campos son requeridos" : errorMsg}/>}
            {success && <SuccessComponent msg={successMsg === "" ? "Promoción cargada exitosamente" : successMsg}/>}

            { showProdServModal && <div className="cc-modal-wrapper fadeIn">
              <div className="cc-modal">
                
                <div className="cc-modal-header mb-2">
                  <div className="no-gutters mb-3 row align-items-center justify-content-spacebetween">
                    <h3 className="mb-0">{promotion.categoriaPromo === "Producto" ? "Productos" : promotion.categoriaPromo === "Servicio" ? "Servicios" : "Combos"}</h3>
                    <div className="row no-gutters position-relative custom-control custom-checkbox">
                      <input onClick={()=>{ setListaCategoriasSelected(listaCategoriasSelected.length > 0 ? [] :  listMain ) }} type="checkbox" className="custom-control-input" id="formsCheckboxDefault"/>
                      <label className="custom-control-label" for="formsCheckboxDefault">{promotion.categoriaPromo === "Producto" ? "Todos los productos" : promotion.categoriaPromo === "Servicio" ? "Todos los servicios" : "Todos los combos"}</label>
                    </div>
                  </div>
                </div>
                {/* <div className="row no-gutters">
                    <div className="col-lg-3">
                        <input onChange={(e)=>{searchByValueInPopUp(e.target.value, "titulo"); }} type="text" placeholder='Nombre' className="form-control col-lg-auto" />
                    </div>
                    <div className="col-lg-3 px-2">
                        <select onChange={(e)=>{searchByValueInPopUp(e.target.value, "categoria"); }} className={`form-control col-lg-12`}>
                            <option value="">Categoria</option>
                                {listaCategorias.map(data => (
                                    <option key={data} value={data}>{data}</option>
                                ))}
                            <option value="Todos">Todos</option>
                        </select>
                    </div>
                    <div className="col-lg-3 px-2">
                        <select onChange={(e)=>{searchByValueInPopUp(e.target.value, ""); }} className={`form-control col-lg-auto`}>
                            <option value="">Edad</option>
                            <option value="Cachorro">Cachorro</option>
                            <option value="Sénior">Sénior</option>
                            <option value="Adulto">Adulto</option>
                            <option value="Todos">Todos</option>
                        </select>
                    </div>
                    <div className="col-lg-3">
                        <select onChange={(e)=>{searchByValueInPopUp(e.target.value, ""); getRazas(e.target.value)}} className={`form-control col-lg-12`}>
                            <option value="">Especie</option>
                                {species.map(data => (
                                    <option key={data} value={data}>{data}</option>
                                ))}
                            <option value="Todos">Todos</option>
                        </select>
                    </div>
                    { razas.length > 0 && <div className="col-lg-3 mt-2">
                        <select onChange={(e)=>{searchByValueInPopUp(e.target.value, ""); }} className={`form-control col-lg-12`}>
                            <option value="">Raza</option>
                            {razas.map((data, i) => (
                                <option key={i} value={data}>{data}</option>
                            ))}
                        </select>
                    </div>}
                </div> */}
                <div className="cc-modal-body" style={{alignContent: "flex-start"}}>
                  {listMain.map((l)=>{
                    return (
                        <div onClick={()=>{ listaCategoriasSelected.includes(l) ? 
                              setListaCategoriasSelected(listaCategoriasSelected.filter((l1) => l1 !== l))
                            : setListaCategoriasSelected([l, ...listaCategoriasSelected]) }} className={`fadeIn variant-item cursor-pointer ${listaCategoriasSelected.includes(l) ? "active" : "" }`} key={l.id}>
                            <div className="variant-item-row">
                                <div className="variant-item-img-col">
                                    <img src={l.img} className=""/>
                                </div>
                                <div className="variant-item-p-col">
                                    <p className="variant-item-p-title">
                                        {l.titulo} 
                                    </p>
                                    <p className="variant-item-p-price">
                                        {l.nombreLocalidad}
                                    </p>
                                </div>
                            </div>
                        </div>

                    )
                  })}
                </div>
                <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                  {/* <div className={`btn ${"btn-primary"}`}> */}
                  <button onClick={()=>{setShowProdServModal(false)}} className={`btn btn-disabled`}>
                    Cancelar
                  </button>
                  <button onClick={()=>{setShowProdServModal(false)}} className={`btn btn-primary`}>
                    Continuar
                  </button>
                </div>
              </div>
            </div> }

            <div style={{ ...navbarStyles, top: visible ? '-60px' : '60px' }}>
                <div className="row no-gutters align-items-center justify-content-spacebetween mb-4">
                    <h4 className="color-primary bold mb-0">Nueva</h4>
                    <div className="row no-gutters">
                        <div onClick={()=>{ checkInputs(promotion) }} className="btn btn-success">Crear promoción</div>
                    </div>
                </div>
            </div>

            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                    <div className="row align-items-center">
                        <div className="col">
                            <p className="page-title bold"><Link className="color-white light" to="/promotions">Promociones</Link> <span>Nuevo</span> </p>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-1 mb-0 level-1">
                    <div className="row align-items-center justify-content-space-around level-2">
                        <i onClick={()=>{}} className="material-icons color-white display-5 cursor-pointer">help_outline</i>
                    </div>
                </div>
            </div>

            <div className="row no-gutters">
                <div className="col-lg-8">
                    
                    <div className="row no-gutters align-items-center justify-content-spacebetween mb-4">
                        <h4 className="color-primary bold mb-0">Nueva</h4>
                        <div className="row no-gutters">
                            <div  onClick={()=>{ 
                                checkInputs(promotion)
                            }} className="btn btn-success">Crear promoción</div>
                        </div>
                    </div>

                    <div className="creation-card mb-3">
                        <div className="creation-card-title">Detalles</div>
                        <div className="creation-card-content">
                            
                            <div className="creation-input-group mb-3 no-gutters mr-4">
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">Código de la promoción</p>
                                </div>
                                <div className="col-lg-auto">
                                    <input value={promoCode} onChange={(e)=>{setPromoCode(e.target.value); }} className={`form-control col-lg-12`} />
                                </div>
                            </div>

                            <div className="creation-input-group mb-3 no-gutters mr-4">
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">Estado</p>
                                </div>
                                <div className="col-lg-auto">
                                    <select value={promotion.status} onChange={(e)=>{setPromotion({...promotion, status: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "status" ) )  }} 
                                    className={`form-control col-lg-12 ${ listErrors.includes("status") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                        <option value="Activo">Activo</option>
                                        <option value="Borrador">Borrador</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("status") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            <div className="creation-input-group-words">

                                <div className="creation-input-group no-gutters mr-2" style={{width: "100%"}}>
                                    <div className="col-lg-5">
                                        <p className="creation-input-label">Etiquetas</p>
                                    </div>
                                    <div className="col-lg-7">
                                        <input ref={inputTag} type="text" onKeyPress={handleKeyPress} onChange={e=>{setPalabra(e.target.value)}}  placeholder="Comida" className="form-control"/>
                                    </div>
                                </div>
                                {palabrasClave.map(p => (
                                    <p className="pill mb-0" key={p}>{p} <span className="cursor-pointer btn-delete" onClick={()=>{ setPalabrasClave(palabrasClave.filter((p1) => p1 !== p)); }} >X</span></p>
                                ))}

                            </div>



                        </div>
                    </div>

                    <div className="creation-card mb-3">
                        <div className="creation-card-title mb-2">Mercado</div>
                        <p className="creation-card-p">Indica a quien está dirigida la promoción</p>
                        <div className="creation-card-content">
                            
                            <div className="mb-2 creation-input-group no-gutters mr-4">
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">Edad</p>
                                </div>
                                <div className="col-lg-auto">
                                    <select value={promotion.edad} onChange={(e)=>{setPromotion({...promotion, edad: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "edad" ) )  }} className={`form-control col-lg-12 ${ listErrors.includes("edad") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                        <option value="Cachorro">Cachorro</option>
                                        <option value="Sénior">Sénior</option>
                                        <option value="Adulto">Adulto</option>
                                        <option value="Todos">Todos</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("edad") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            <div className="mb-2 creation-input-group no-gutters mr-4">
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">Especie</p>
                                </div>
                                <div className="col-lg-auto">
                                    <select value={promotion.tipoMascota} onChange={(e)=>{setPromotion({...promotion, tipoMascota: e.target.value}); getRazas(e.target.value); setListErrors(listErrors.filter( prev => prev !== "tipoMascota" ) )    }} className={`form-control col-lg-12 ${ listErrors.includes("tipoMascota") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                            {species.map(data => (
                                                <option key={data} value={data}>{data}</option>
                                            ))}
                                        <option value="Todos">Todos</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("tipoMascota") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            { razas.length > 0 && <div className="mb-2 creation-input-group no-gutters">
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">Raza</p>
                                </div>
                                <div className="col-lg-auto">
                                    <select value={promotion.dirigido} onChange={(e)=>{setPromotion({...promotion, dirigido: e.target.value})}} className={`form-control col-lg-12`}>
                                        <option value="">Selección</option>
                                        {razas.map((data, i) => (
                                            <option key={i} value={data}>{data}</option>
                                        ))}
                                        <option value="Todos">Todos</option>
                                    </select>
                                </div>
                            </div> }

                        </div>
                    </div>
                    
                    <div className="creation-card mb-3">
                        <div className="creation-card-title mb-2">Vigencia</div>
                        <p className="creation-card-p">-</p>
                        <div className="creation-card-content">
                            
                            <div className="creation-input-group no-gutters mr-4">
                                <div className="col-lg-auto mr-2">
                                    <input onChange={(e)=>{setPromotion({...promotion, limitInQuotas: !promotion.limitInQuotas})}} type="checkbox" className={`form-control col-lg-12`} />
                                </div>
                                <div className="col-lg-auto">
                                    <p className="creation-input-label">Cantidad limitada</p>
                                </div>
                            </div>
                            
                            <div className="creation-input-group no-gutters">
                                <div className="col-lg-auto mr-2">
                                    <input onChange={(e)=>{setPromotion({...promotion, limitInTime: !promotion.limitInTime})}} type="checkbox" className={`form-control col-lg-12`} />
                                </div>
                                <div className="col-lg-auto">
                                    <p className="creation-input-label">Desde - Hasta</p>
                                </div>
                            </div>

                        </div>
                    </div>
                   
                    <div className="creation-card mb-3">
                        <div className="creation-card-title mb-2">Tipo</div>
                        <div className="creation-card-content">
                            
                            <div className="creation-input-group no-gutters mr-4">
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">Categoría</p>
                                </div>
                                <div className="col-lg-auto">
                                    <select value={promotion.categoriaPromo} onChange={(e)=>{setPromotion({...promotion, categoriaPromo: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "categoriaPromo" ) ); setListaCategoriasSelected([]) }} className={`form-control col-lg-12 ${ listErrors.includes("categoriaPromo") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                        <option value="Producto">Producto</option>
                                        <option value="Servicio">Servicio</option>
                                        <option value="Combo">Combo</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("categoriaPromo") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            <div className="creation-input-group no-gutters">
                                <div className="col-lg-auto mr-2">
                                    <p className="creation-input-label">Aplica a</p>
                                </div>
                                <div className="col-lg-auto">
                                    <select value={promotion.aplicaA} onChange={(e)=>{setPromotion({...promotion, aplicaA: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "aplicaA" ) ); changeAplica(e.target.value)  }} className={`form-control col-lg-12 ${ listErrors.includes("aplicaA") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                        <option value="Todas las categorías">Todas las categorías</option>
                                        <option value="Una o varias categorías">Una o varias categorías</option>
                                        <option value="Uno o varios">Uno o varios</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("aplicaA") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            {/* <div className="creation-input-group no-gutters mt-2 mb-3" style={{width: "50%"}}>
                                <div className="col-lg-3">
                                    <p className="creation-input-label">Tipo</p>
                                </div>
                                <div className="col-lg-9">
                                    <select value={promotion.tipoPromo} onChange={(e)=>{setPromotion({...promotion, tipoPromo: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "tipoPromo" ) )  }} className={`form-control col-lg-12 ${ listErrors.includes("tipoPromo") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                        <option value="desc">Descuento</option>
                                        <option value="llevaXY">Lleva X y paga Y</option>
                                        <option value="segundoProd">Segundo producto con descuento</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("tipoPromo") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div> */}
                            
                            <div className="creation-input-group mb-0" style={{width: "100%"}}>
                                { promotion.tipoPromo === "desc" && <p style={{fontSize: "13px"}} className="creation-card-p mb-3">{tipoPromoValores.desc}% de descuento directo sobre el precio del producto</p> }
                                { promotion.tipoPromo === "llevaXY" && <p style={{fontSize: "13px"}} className="creation-card-p mb-3">El cliente compra {tipoPromoValores.paga} cantidad y se lleva {tipoPromoValores.lleva} cantidad</p> }
                                { promotion.tipoPromo === "segundoProd" && <p style={{fontSize: "13px"}} className="creation-card-p mb-3">El cliente compra un producto y el segundo tiene un descuento del {tipoPromoValores.descSeg}%</p> }
                            </div>

                            {/* Selección de categorias */}
                                { promotion.aplicaA === "Una o varias categorías" && <div className="position-relative mb-3 mt-3">
                                    <select onChange={(e)=>{ (listaCategoriasSelected.includes(e.target.value) || e.target.value === "") ? console.log("Lo contiene") : setListaCategoriasSelected([...listaCategoriasSelected, {titulo: e.target.value, tipo: ""}]) }} style={{width: "200px"}} className={`form-control mr-2`}>
                                        <option value="">Seleccionar categorías</option>
                                        {listaCategorias.map((cat, i)=>{
                                            return(
                                                <option key={i} value={cat}>{cat}</option>
                                            )
                                        })}
                                    </select>
                                    
                                    { listaCategoriasSelected.length > 0 && <div className="mt-3 row no-gutters" style={{width: "100%"}}>

                                        <p className="creation-input-label mr-2">Categorias seleccionadas: </p>
                                        {listaCategoriasSelected.map((loc, i) => {
                                            return (
                                                <p onClick={()=>{ setListaCategoriasSelected(listaCategoriasSelected.filter((prv)=> (prv !== loc) )) }} key={i} className="creation-input-label-pill cursor-pointer">
                                                    {loc.titulo}
                                                </p>
                                            )
                                        })}
                                    </div> }

                                </div> }
                            {/* End Selección de categorias */}
                            {/* Selección de productos o servicios */}
                                { promotion.aplicaA === "Uno o varios" && <div className="position-relative my-3">

                                    <div onClick={()=>{ setShowProdServModal(true) }} className="btn btn-primary">Seleccionar {promotion.categoriaPromo === "Producto" ? "producto" : promotion.categoriaPromo === "Servicio" ? "servicio" : "combo"}</div>
                                    
                                    { listaCategoriasSelected.length > 0 && <div className="mt-3 row no-gutters" style={{width: "100%"}}>

                                        <p className="creation-input-label mr-2">{promotion.categoriaPromo === "Producto" ? "Productos" : promotion.categoriaPromo === "Servicio" ? "Servicios" : "Combos"} seleccionados: </p>
                                        {listaCategoriasSelected.map((loc, i) => {
                                            return (
                                                <p onClick={()=>{ setListaCategoriasSelected(listaCategoriasSelected.filter((prv)=> (prv !== loc) )) }} key={i} className="creation-input-label-pill cursor-pointer">
                                                    {loc.titulo} <b>X</b>
                                                </p>
                                            )
                                        })}
                                    </div> }

                                </div> }
                            {/* End Selección de productos o servicios */}

                            {/* Lista de seleccionados productos o servicios*/}
                                { promotion.aplicaA === "Todas las categorías" && <div className="promotion-list-card mt-3">
                                    <div className="promotion-list-title" style={{width: "23%"}}>
                                        <p className="creation-input-label">Todas las categorias</p>
                                    </div>
                                    <select className={`form-control mr-2`} style={{width: "30%"}}>
                                        <option value="">Tipo</option>
                                        <option value="desc">Descuento</option>
                                        <option value="llevaXY">Lleva X y paga Y</option>
                                        <option value="segundoProd">Segundo producto con descuento</option>
                                    </select>
                                    { promotion.tipoPromo === "segundoProd" && <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                        <p className="creation-input-label mr-2">Descuento</p>
                                        <input type="number" min="0" value={tipoPromoValores.descSeg} onChange={(e)=>{ setTipoPromoValores({...tipoPromoValores, descSeg: e.target.value}) }} className={`form-control mr-2`} />
                                        <p style={{width: "2%"}} className="creation-input-label">%</p>
                                    </div> }
                                    { promotion.tipoPromo === "llevaXY" && <div className="creation-input-group no-gutters" style={{width: "40%"}}>
                                        <div className="col-lg-1">
                                            <p className="creation-input-label">Lleva</p>
                                        </div>
                                        <div className="col-lg-4">
                                            <input type="number" min="0" value={tipoPromoValores.lleva} onChange={(e)=>{ setTipoPromoValores({...tipoPromoValores, lleva: e.target.value}) }} className={`form-control`} />
                                        </div>
                                        <div className="col-lg-1">
                                            <p className="creation-input-label">Paga</p>
                                        </div>
                                        <div className="col-lg-4">
                                            <input type="number" min="0" value={tipoPromoValores.paga} onChange={(e)=>{ setTipoPromoValores({...tipoPromoValores, paga: e.target.value}) }} className={`form-control`} />
                                        </div>
                                    </div> }
                                    { promotion.tipoPromo === "desc" && <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                        <p className="creation-input-label mr-2">Descuento</p>
                                        <input type="number" min="0" value={tipoPromoValores.desc} onChange={(e)=>{ setTipoPromoValores({...tipoPromoValores, desc: e.target.value}) }} className={`form-control mr-2`} />
                                        <p style={{width: "2%"}} className="creation-input-label">%</p>
                                    </div> }
                                </div> }
                                
                                { promotion.aplicaA === "Una o varias categorías" && <div className="position-relative" style={{width: "100%"}}>
                                    {listaCategoriasSelected.map((ele, i)=>{
                                        return(
                                            <div key={i} className="promotion-list-card mb-3">
                                                <div className="promotion-list-title" style={{width: "23%"}}>
                                                    <p className="creation-input-label">{ele.titulo}</p>
                                                </div>
                                                <select onClick={(e)=>{ changeTipoCateSelected( e.target.value, i) }} className={`form-control mr-2`} style={{width: "30%"}}>
                                                    <option value="">Tipo</option>
                                                    <option value="desc">Descuento</option>
                                                    <option value="llevaXY">Lleva X y paga Y</option>
                                                    <option value="segundoProd">Segundo producto con descuento</option>
                                                </select>
                                                { ele.tipo === "segundoProd" && <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                                    <p className="creation-input-label mr-2">Descuento</p>
                                                    <input type="number" min="0" value={tipoPromoValores.descSeg} onChange={(e)=>{ setTipoPromoValores({...tipoPromoValores, descSeg: e.target.value}) }} className={`form-control mr-2`} />
                                                    <p style={{width: "2%"}} className="creation-input-label">%</p>
                                                </div> }
                                                { ele.tipo === "llevaXY" && <div className="creation-input-group no-gutters" style={{width: "40%"}}>
                                                    <div className="col-lg-1">
                                                        <p className="creation-input-label">Lleva</p>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <input type="number" min="0" value={tipoPromoValores.lleva} onChange={(e)=>{ setTipoPromoValores({...tipoPromoValores, lleva: e.target.value}) }} className={`form-control`} />
                                                    </div>
                                                    <div className="col-lg-1">
                                                        <p className="creation-input-label">Paga</p>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <input type="number" min="0" value={tipoPromoValores.paga} onChange={(e)=>{ setTipoPromoValores({...tipoPromoValores, paga: e.target.value}) }} className={`form-control`} />
                                                    </div>
                                                </div> }
                                                { ele.tipo === "desc" && <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                                    <p className="creation-input-label mr-2">Descuento</p>
                                                    <input type="number" min="0" value={tipoPromoValores.desc} onChange={(e)=>{ setTipoPromoValores({...tipoPromoValores, desc: e.target.value}) }} className={`form-control mr-2`} />
                                                    <p style={{width: "2%"}} className="creation-input-label">%</p>
                                                </div> }
                                            </div>
                                        )
                                    })}
                                </div> }
                                
                                { promotion.aplicaA === "Uno o varios" && <div className="position-relative" style={{width: "100%"}}>
                                    {listaCategoriasSelected.map((ele, i)=>{
                                        return(
                                            <div key={i} className="promotion-list-card mb-3">
                                                <div className="promotion-list-title" style={{width: "23%"}}>
                                                    <p className="creation-input-label">{ele.titulo}</p>
                                                </div>
                                                <select onClick={(e)=>{ changeTipoCateSelected( e.target.value, i) }} className={`form-control mr-2`} style={{width: "30%"}}>
                                                    <option value="">Tipo</option>
                                                    <option value="desc">Descuento</option>
                                                    <option value="llevaXY">Lleva X y paga Y</option>
                                                    <option value="segundoProd">Segundo producto con descuento</option>
                                                </select>
                                                { ele.tipo === "segundoProd" && <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                                    <p className="creation-input-label mr-2">Descuento</p>
                                                    <input type="number" min="0" onChange={(e)=>{ changeValCateSelected(ele.tipo, i, e.target.value) }} className={`form-control mr-2`} />
                                                    <p style={{width: "2%"}} className="creation-input-label">%</p>
                                                </div> }
                                                { ele.tipo === "llevaXY" && <div className="creation-input-group no-gutters" style={{width: "40%"}}>
                                                    <div className="col-lg-1">
                                                        <p className="creation-input-label">Lleva</p>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <input type="number" min="0" onChange={(e)=>{ changeValCateSelected(ele.tipo, i, e.target.value) }} className={`form-control`} />
                                                    </div>
                                                    <div className="col-lg-1">
                                                        <p className="creation-input-label">Paga</p>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <input type="number" min="0" onChange={(e)=>{ changeValCateSelected(ele.tipo, i, 0, e.target.value) }} className={`form-control`} />
                                                    </div>
                                                </div> }
                                                { ele.tipo === "desc" && <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                                    <p className="creation-input-label mr-2">Descuento</p>
                                                    <input type="number" min="0" onChange={(e)=>{ changeValCateSelected(ele.tipo, i, e.target.value) }} className={`form-control mr-2`} />
                                                    <p style={{width: "2%"}} className="creation-input-label">%</p>
                                                </div> }
                                            </div>
                                        )
                                    })}
                                </div> }
                            {/* End lista de seleccionados productos o servicios*/}
                            
                            {/* Lista de seleccionados categorias*/}
                            {/* End lista de seleccionados categorias*/}

                        </div>
                    </div>

                </div>
                <div className="col-lg-4 pl-4">
                    
                    <div className="creation-card mb-5 p-3">
                        <div className="creation-card-content">
                            <div className="position-relative">
                                <input type="file" ref={hiddenFileInput} onChange={handleChange}  style={{display: 'none'}} />
                                <div onClick={handleClick} className={`creation-input-photo ${ listErrors.includes("img") && "border-danger" }`}>
                                {src !== "" ? <img src={src} alt="" /> : <div className={`creation-input-photo-inside`}><p className="material-icons icon mb-0">image</p></div>}
                                </div>
                                <div style={{textAlign: "center", width: "100%"}}>
                                    <p style={{fontSize: "13px", color: "#a3a6af"}} className="my-3">Dimensiones recomendadas (200 x 300)</p>
                                </div>
                            </div>
                            
                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Titulo</p>
                                </div>
                                <div className="col-lg-12">
                                    <input value={promotion.titulo} onChange={(e)=>{setPromotion({...promotion, titulo: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "titulo" ) )  }} placeholder="Título del promoción" className={`form-control col-lg-12 ${ listErrors.includes("titulo") && "border-danger" } `}/>
                                </div>
                                 <div className="creation-errors-container">
                                    {listErrors.includes("titulo") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>

                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Descripción</p>
                                </div>
                                <div className="col-lg-12">
                                    <textarea value={promotion.descripcion} onChange={(e)=>{setPromotion({...promotion, descripcion: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "descripcion" ) )  }} placeholder="Descripción del promoción" className={`form-control col-lg-12 ${ listErrors.includes("descripcion") && "border-danger" } `}/>
                                </div>
                                 <div className="creation-errors-container">
                                    {listErrors.includes("descripcion") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Condiciones</p>
                                </div>
                                <div className="col-lg-12">
                                    <textarea value={promotion.condiciones} onChange={(e)=>{setPromotion({...promotion, condiciones: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "condiciones" ) )  }} placeholder="Condiciones de la promoción" className={`form-control col-lg-12 ${ listErrors.includes("condiciones") && "border-danger" } `}/>
                                </div>
                                 <div className="creation-errors-container">
                                    {listErrors.includes("condiciones") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Fecha desde</p>
                                </div>
                                <div className="col-lg-12">
                                    <input className="form-control col-lg-12" onChange={(e)=>{setPromotion({...promotion, dateStart: e.target.value})}} type="date" min={minDate}/>
                                </div>
                            </div>
                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Fecha hasta</p>
                                </div>
                                <div className="col-lg-12">
                                    <input className="form-control col-lg-12" onChange={(e)=>{setPromotion({...promotion, dateEnd: e.target.value})}} type="date" min={minDate}/>
                                </div>
                            </div>

                            <div className="creation-input-group-grid no-gutters">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Cupos</p>
                                </div>
                                <div className="col-lg-12">
                                    <input type="number" min="0" value={promotion.cupos} onChange={(e)=>{setPromotion({...promotion, cupos: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "cupos" ) )  }} placeholder="0" className={`form-control col-lg-12 ${ listErrors.includes("cupos") && "border-danger" } `}/>
                                </div>
                                 <div className="creation-errors-container">
                                    {listErrors.includes("cupos") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )

    async function uploadPromotion() {
        
        setBtnMessage("Subiendo...")
        let id = firebase.db.collection("Promociones").doc().id;
        try {
          await firebase.storage.ref(`/Promociones imagenes/${file.name}`).put(file)
          firebase.storage.ref("Promociones imagenes").child(file.name).getDownloadURL().then((url) => {
            firebase.db.collection("Promociones").doc(id).set({
                aliadoId: user.aliadoId,
                isApproved: false,
                promoId: id,
                urlImagen: url,
                pais: user.pais,
                cupos: parseInt(promotion.cupos),
                aplicaA: promotion.aplicaA,
                categoriaPromo: promotion.categoriaPromo,
                status: promotion.status,
                titulo: promotion.titulo,
                descripcion: promotion.descripcion,
                dirigido: promotion.dirigido,
                limitInQuotas: promotion.limitInQuotas,
                limitInTime: promotion.limitInTime,
                edad: promotion.edad,
                tipoMascota: promotion.tipoMascota,
                dateStart: promotion.dateStart,
                dateEnd: promotion.dateEnd,
                ordersTotal: 0,
                ordersAmount: 0,
                codigo: promoCode,
                promotedElements: listaCategoriasSelected,
                createdOn: moment().toDate(),
            }).then((val)=>{
                setSuccess(true)
                setPromotion({})
                setSuccessMsg("Promoción cargada exitosamente")
                setTimeout(() => {
                  setSuccess(false)
                }, 4000);
                setBtnMessage("Crear promoción")
                window.scrollTo(0, 0)
            })
          })
          
        } catch(error) {
          alert(error.message)
        }
    }

}

export default UploadPromotion
